export default __webpack_public_path__ + "static/media/mac.b7941bf2.jpg";